const FeedbackGuideForSpeaking = () => {
  return (
    <>
&lt;영문&gt;<br />
Watch the recorded speech carefully and then provide concise and easy-to-understand feedback to the student.<br />
General Comments may cover topic relevancy, overall coherence or construction, pronunciation accuracy or fluency, etc.<br />
Try to revise at least one of the student's sentences. Focus on sentences that are grammatically incorrect and/or illogical. Sentence Revisions may also suggest more appropriate topic sentences or supporting details.<br />
<br />
&lt;국문&gt;<br />
녹음된 스피치 영상을 확인한 후 다음과 같이 comment를 남겨 주세요.<br />
<u>General Comments:</u><br />
&emsp;(1)	주제와의 연관성<br />
&emsp;(2)	전체적인 일관성 또는 내용 구조<br />
&emsp;(3) 발음이나 유창성<br />
등에 관해 전체적인 평가를 간결하고 알기 쉬운 표현으로 제공해주세요.<br />
<u>Sentence Revision:</u><br />
학생의 문장을 수정해 대안이 되는 문장을 제시해 주십시오. 특히,<br />
&emsp;(1) 문법상 틀린 부분<br />
&emsp;(2) 논리적으로 부적절한 문장<br />
등에 관해 수정된 문장을 입력하면서, 더 적절한 topic sentence나 supporting ideas를 제공해 주십시오.    
    </>
  );
}

export default FeedbackGuideForSpeaking;
